import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as routeBound from '../../../route-bound'
import * as recordAssignedOrgs from '../record-assigned-orgs'

import { Api } from './api.service'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Provides the list of lab space records that can still be assigned to the
 * current lab service (i.e. lab records not yet assigned to it).
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const scenarioContext = ngCore.inject(routeBound.scenario.Context.TOKEN)
    const recordAssignedOrgsEc = ngCore.inject(recordAssignedOrgs.Collection)

    super({
      api: ngCore.inject(Api),
      context$: scenarioContext,
      identify: record => record.id,
      name: ec.Name.Predefined.SpaceLabAssignableRecord,
      plugins: {
        additionalFactories: [
          new plugins.spaceDimensionFilter.Factory(),
          new plugins.responsiblePersonFilter.Factory(),
          new plugins.clusterDimensionFilter.Factory(),
        ],
      },
    })

    this.feature.registerEffects(
      effects.applyFiltersOnSelection(this),
      effects.resetFiltersOnModalOpen(this, recordAssignedOrgsEc),
      effects.reseedEditedParamsOnApply(this),
      effects.releaseSelectionOnModalClose(this),
    )
  }
}
